import ListFieldsGeneric from './ListFieldsGeneric' // Template für Listen-Elemente
let ListFields = ListFieldsGeneric('Mittelgeber') // Initialisieren des Templates für eine bestimmte Entität

export default {
  label: 'Mittelgeber',
  route: 'mittelgeber',
  className: 'mittelgeber',
  fields: [
    ListFields.SortableField('name', true),
    ListFields.SortableField('finSchluessel', true)
  ]
}



// WEBPACK FOOTER //
// ./src/schema/list/Mittelgeber.js